import React, { Component } from "react";
import { ajaxWrapper } from "functions";

import SpellTop from "pages/action/spell_top.js";
import SpellHigher from "pages/action/spell_higher.js";
import ActionTags from "pages/action/tags.js";

export default class ActionCard extends React.Component {
	render() {
		var action = this.props.action;

		var description = action.description.split(/\r?\n|\r|\n/);
		var description_jsx = [];
		for (let item of description) {
			description_jsx.push(<p style={{ textIndent: "15px" }}>{item}</p>);
		}

		var spell_top = null;
		var spell_higher = null;
		if (action.action_type == "Legendary") {
		} else if (action.action_type == "Ability") {
		} else if (action.action_type == "Spell") {
			spell_top = <SpellTop spell={action} action_use={this.props.action_use} />;
			spell_higher = <SpellHigher spell={action} />;
		} else if (action.action_type == "Feat") {
		} else {
			spell_top = (
				<div className="row">
					<div className="col-12">
						<p>
							<b>Range: </b> {action.range}
						</p>
					</div>
				</div>
			);
		}

		return (
			<div className="stat-block-wrapper">
				<div className="stat-block">
					<div className="row">
						<div className="col-12">
							<br />
							<h2 className="header">{action.name}</h2>
						</div>
						{spell_top}
						<div
							className="col-12"
							style={{
								whiteSpace: "break-spaces",
								lineHeight: "normal",
							}}
						>
							{description_jsx}
						</div>
						{spell_higher}
						<div className="col-12">
							<ActionTags action={action} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
